export class Usuario{
    nombreUsuario:string;
    contrasena:string;
}